<div class="modal-content" 
        [class.large]="size() === 'large'" 
        [class.medium]="size() === 'medium'" 
        [class.small]="size() === 'small'"
    >
    @if(closable()) {
        <button id="close-modal" type="button" class="close" (click)="close.emit(true)"><span class="icon-close-x"></span></button>
    }
    <div class="header-wrapper" [class.header-wrapper-center]="centerTitle()">
        <ng-content select="[header]"></ng-content>
    </div>
    <ng-content></ng-content>
    <div class="footer-wrapper">
        <ng-content select="[footer]"></ng-content>
    </div>
</div>